import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <div className="w-full bg-vertLogo text-white text-center py-3 px-4 font-bold  z-90">
      Les inscriptions pour la petite section sont ouvertes !{" "}
      <Link
        to="/modalites-inscription"
        className="underline text-yellow-300 hover:text-yellow-200 transition-colors"
      >
        Inscrivez-vous ici
      </Link>
    </div>
  );
};

export default Banner;
